/* src/app/modules/shared/components/member-badges/member-badges.component.scss */
#badge {
  color: white !important;
  border: 1px solid;
  cursor: pointer;
}
#badge > mat-icon {
  margin-right: 5px;
}
/*# sourceMappingURL=member-badges.component.css.map */
